import React from 'react';
import { styled } from 'styled-components';

const PropertiesPanelPropertyContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 20px;
    font-family: ${(props) => props.theme.app.font};
    padding: 10px 0;
`;

export const PropertiesPanelProperty = (props: { children: React.ReactNode }) => {
    return <PropertiesPanelPropertyContainer>{props.children}</PropertiesPanelPropertyContainer>;
};

export const PropertiesPanelLabel = styled.label`
    font-size: 14px;
`;

export const PropertiesPanelControl = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
    position: relative;
`;

export const PropertiesPanelPropertyContent = styled.div`
    grid-column: 1 / span 2;
`;
